import { SigninLang } from './register/signin/signin.lang';
import { ProfileLang } from './questioner/profile/profile.lang';
import { answerDetailLang } from './questioner/publishDetail/answerDetail/answerDetail.lang';
import { componentsLang } from './components/components.lang';
import { utilitiesLang } from 'utilities/utilities.lang';
import { publishDetailLang } from './questioner/publishDetail/publishDetail.lang';
import { SLPLang } from './SLP/SLP.lang';
import { KioskLang } from './kiosk/kiosk.lang';
import { WSPanelAllLang } from './questioner/wsPanel/wsPanel.lang';
import { NotificationLang } from './questioner/notification/notification.lang';
import { PortalLang } from './portal/portal.lang';

export const uCheckLang = {
    signin: SigninLang,
    profile: ProfileLang,
    answerDetail: answerDetailLang,
    components: componentsLang,
    utilities: utilitiesLang,
    publishDetail: publishDetailLang,
    SLP: SLPLang,
    kiosk: KioskLang,
    wsPanel: WSPanelAllLang,
    notification: NotificationLang,
    portal: PortalLang,
    errorNoInternet: 'جهت به روز رسانی داده های خود باید دستگاه تان را به اینترنت متصل کنید',
    newVersion: 'نسخه جدیدی از برنامه منتشر شده است. آیا مایل به بروزرسانی هستید؟',
    download: 'دانلود',
    cancel: 'انصراف',
    criticalVersion: 'نسخه جدیدی از برنامه منتشر شده است و لازم است برای ادامه کار با این برنامه آن را نصب کنید ',
    serverErr: 'خطای ارتباط با سرور رخ داده است. لطفا بعدا تلاش کنید.',
    unknownErr: 'درخواست با خطا مواجه شد. از اتصال به دستگاه به اینترنت اطمینان حاصل کنید.',
    attachFileErrorCode: {
        noWorkspaceOrUser: 'فضای کاری یا کاربری برای بارگزاری عکس معرفی نشده',
        uploadSizeLimit: 'حجم بارگزاری اکانت شما به پایان رسیده. برای افزایش حجم اکانت خود را ارتقا دهید.',
        notAllowedExtension: 'تایپ فایل وارد شده اشتباه است. لطفا یک فایل با فرمت jpg، jpeg، png یا gif آپلود کنید.',
        tooLargeFile: 'حجم فایل ارسال شده بیشتر از حد مجاز است. لطفا فایل خود را فشرده کتید یا فایل دیگری ارسال کتید.',
    },
};
